import { render, staticRenderFns } from "./ThankYouPage.vue?vue&type=template&id=5a270458&scoped=true"
import script from "./ThankYouPage.vue?vue&type=script&lang=ts"
export * from "./ThankYouPage.vue?vue&type=script&lang=ts"
import style0 from "./ThankYouPage.vue?vue&type=style&index=0&id=5a270458&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a270458",
  null
  
)

export default component.exports